import {
  ChangeDetectionStrategy,
  Component,
  input,
  Input,
} from '@angular/core';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'twc-logo',
  imports: [RouterLink],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  @Input({ required: true }) path: string;
  darkPath = input<string>();
  @Input() withLink = true;
}
